import installElement from '@/plugins/element'
import modal from '@/plugins/modal'

export default function installPlugins(app) {
  installElement(app)
  app.config.globalProperties.$modal = modal
}
